import React from 'react';
import { CalendarClockIcon, ComponentIcon, CpuIcon, ShuffleIcon } from 'lucide-react';
import { Section } from '../Section';
import { Panel } from '../ui/Panel';
import { Pill } from '../ui/Pill';
import { constraints } from '../../data/caseStudy';
const icons = [CalendarClockIcon, ComponentIcon, CpuIcon, ShuffleIcon];
export function Context() {
  return <Section number="01" kicker="Context" title="Integrated intelligence, one product, one fixed date" lede="Lumen brings together specialist global gas and LNG market data, a scenario modelling engine with 1.5 million variables, over 100 years of combined senior analyst expertise, and an AI-powered interface in a single, integrated platform." tone="mist" data-id="element-73" data-mp="2bhz3yzrtbinv">
      <div className="grid grid-cols-12 gap-8" data-id="element-74" data-mp="1sm90t9858g8e">
        <div className="col-span-7" data-id="element-75" data-mp="1snk5rcdbru13">
          <Panel padding="lg" data-id="element-76" data-mp="3rylb299mzlst">
            <Pill variant="green" data-id="element-77" data-mp="3rxtfgyg1ho2j">Starting position</Pill>
            <p className="mt-6 font-display text-[22px] font-medium leading-[1.45] tracking-[-0.015em] text-navy" data-id="element-78" data-mp="3myp72a0xvud9">
              High stakes, high internal visibility, and a launch date that had been set before I
              joined.
            </p>
            <p className="mt-5 font-sans text-[16px] leading-[1.75] text-ink-muted" data-id="element-79" data-mp="pykimwzx7c7t">
              I joined late with no room to move the deadline, so the work had to be shaped around it: sequence by impact, keep the surface area modular and make every review count.


My job was to design an interactive infrastructure map with dynamic layer controls, letting users toggle data layers on and off and see live results, alongside tightening up the general UX across the product. 


After a quick onboarding, I started by mapping the existing state of the product and identifying the highest impact gaps, then worked in parallel streams so the map and the wider UX could move at the same time.
            </p>
          </Panel>
        </div>

        <div className="col-span-5 grid grid-cols-1 gap-4" data-id="element-80" data-mp="1sbhx9xflhvl7">
          {constraints.map((item, i) => {
          const Icon = icons[i];
          return <Panel key={item} padding="sm" className="flex items-start gap-4" data-id="element-81" data-mp="22789gfqfyaeu" data-mpi={i}>
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-green-soft" data-id="element-82" data-mp="1x9owrk9e65p0">
                  <Icon className="h-4 w-4 text-green-deep" aria-hidden="true" data-id="element-83" data-mp="1s7zjrz2lzhya" />
                </span>
                <p className="font-sans text-[15px] font-medium leading-snug text-navy" data-id="element-84" data-mp="1n9y3tn0hbyr1">{item}</p>
              </Panel>;
        })}
        </div>
      </div>
    </Section>;
}